var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSessionPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19,
    fill: "currentColor",
    viewBox: "0 0 22 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.11 4.865a.949.949 0 0 0-.05-.001c-.548 0-.93.168-1.386.37-.656.29-1.465.648-3.147.668-1.682-.02-2.49-.378-3.147-.668-.455-.202-.837-.37-1.386-.37-.859 0-2.473 1.2-3.195 5.268-.411 2.322-.858 5.789.207 6.205.912.357 1.41-.147 2.106-.852.314-.32.67-.68 1.122-1.02 1.477-1.109 2.186-1.37 4.293-1.37 2.108 0 2.817.261 4.293 1.37.453.34.809.7 1.123 1.02.697.705 1.194 1.208 2.106.852 1.049-.41.63-3.78.224-6.102a3.028 3.028 0 0 1-2.895-1.747.818.818 0 0 1-1.578-.306c0-.457.366-.826.818-.826a.81.81 0 0 1 .505.175 3.145 3.145 0 0 1-.014-.296v-2.37ZM3.617 9.008c0 .911.732 1.651 1.637 1.651.903 0 1.636-.74 1.636-1.651 0-.913-.732-1.652-1.636-1.652-.905 0-1.637.739-1.637 1.652Zm6.546.825a.82.82 0 0 0 .818.826.821.821 0 0 0 .818-.826.821.821 0 0 0-.818-.825.821.821 0 0 0-.818.825Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.175 4.007a1 1 0 0 1 0 1.714l-4.914 2.955a1 1 0 0 1-1.515-.857V1.91a1 1 0 0 1 1.515-.858l4.914 2.956Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionPlay);
export default __webpack_public_path__ + "static/media/SessionPlay.ea7872cc99b3ff60075987c529d537d7.svg";
export { ForwardRef as ReactComponent };